import { render, staticRenderFns } from "./CardTransferenciaCuenta.vue?vue&type=template&id=60ad1ca2&scoped=true&"
import script from "./CardTransferenciaCuenta.vue?vue&type=script&lang=js&"
export * from "./CardTransferenciaCuenta.vue?vue&type=script&lang=js&"
import style0 from "./CardTransferenciaCuenta.vue?vue&type=style&index=0&id=60ad1ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ad1ca2",
  null
  
)

export default component.exports